import { render, staticRenderFns } from "./VariablesGlobales.view.vue?vue&type=template&id=48ba7237"
import script from "./VariablesGlobales.view.vue?vue&type=script&lang=js"
export * from "./VariablesGlobales.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports